function setCaretXY(elem, real_element, caret) {
  var rects = document.getElementById("search-input__ghost").getClientRects();
  var lastRect = rects[rects.length - 1];
  var realElementOffset = jQuery(real_element).offset();

  var x = lastRect.left + lastRect.width - realElementOffset.left + document.body.scrollLeft;
  if (x === 10) {
    x = 0; // Placeholder padding hack
  }
  jQuery(caret).css('left',x);
}

function moveCaret(fakeCaretInput, fakeCaretInputGhost, fakeCaret) {
  jQuery(fakeCaretInputGhost).text(jQuery(fakeCaretInput).val().substring(0, jQuery(fakeCaretInput)[0].selectionStart).replace(/\n$/, '\n\u0001'));
  setCaretXY(fakeCaretInputGhost, fakeCaretInput, fakeCaret);
}

function fakeCaretInit(fakeCaretInput, fakeCaretInputGhost, fakeCaret) {
  if (jQuery(fakeCaretInput).length) {

    // Inject required markup before input
    jQuery('<div class="search-input__caret"></div><div class="search-input__caret-container"><span id="search-input__ghost" class="search-input__ghost h4"></span></div>').insertAfter(jQuery(fakeCaretInput));

    // Be sure the fake caret is in the right starting position
    var fakeInputOffset = jQuery(fakeCaretInput).offset(),
      fakeCaretInputGhostOffset = jQuery(fakeCaretInputGhost).offset(),
      fakeCaretOffset = (fakeCaretInputGhostOffset.left - fakeInputOffset.left);

    jQuery(fakeCaretInput).on("input keydown keyup propertychange click paste cut copy mousedown mouseup change", function () {
      moveCaret(fakeCaretInput, fakeCaretInputGhost, fakeCaret);
    });

    jQuery(fakeCaretInput).on("blur", function () {
      jQuery(this)[0].setSelectionRange(0, 0);
      moveCaret(fakeCaretInput, fakeCaretInputGhost, fakeCaret);
    });
  }
}
